module.exports = __webpack_public_path__ + "936f8054ed4cbd0b29828e6cc981e4b7.png";